var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-expanding-accordion",
    {
      staticClass: "bg-greige px-1",
      attrs: {
        "with-icon": "",
        "icon-name": "icon-rewards",
        "link-title": _vm.title,
        "link-id": "refunds-button",
        "collapsed-block-id": "refunds-detail",
      },
    },
    [
      _c(
        "ul",
        { staticClass: "list mb-0" },
        [
          _vm._l(_vm.odrs, function (odr, index) {
            return _c(
              "li",
              { key: index },
              [
                _c("odr", {
                  attrs: {
                    "modal-id": "popin-odr-" + _vm.deviceSeoId + "-" + index,
                    "odr-name": odr.name,
                    "odr-amount-in-cents": odr.amountInCents,
                    "odr-start-date": odr.dates.start,
                    "odr-end-date": odr.dates.end,
                    "odr-link": odr.link,
                    "promo-odr-messages": _vm.refundMessages.odrMessages,
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.onlineRecovery || _vm.storeRecovery
            ? _c(
                "li",
                [
                  _c("ob1-liens", {
                    staticClass: "p-0",
                    attrs: {
                      "is-button": "",
                      "modal-id": "mobile-recovery-popin",
                      "data-toggle": "modal",
                      text: _vm.refundMessages.recoveryTitle,
                      "data-oevent-label": "tout_savoir_sur_la_reprise",
                      "data-oevent-action": _vm.recoveryValue.tmsAction,
                      "data-oevent-category": _vm.recoveryValue.tmsZone,
                    },
                  }),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-unstyled" }, [
                    _c(
                      "li",
                      { staticClass: "row" },
                      [
                        _c(
                          "span",
                          { staticClass: "col-12 col-md-8 pl-0" },
                          [
                            _vm.recoveryValue.recyclingUrl
                              ? _c("ob1-liens", {
                                  staticClass: "p-0 text-left",
                                  attrs: {
                                    "is-link": "",
                                    href: _vm.recoveryValue.recyclingUrl,
                                    text: _vm.recoveryValue.label,
                                    "data-oevent-label":
                                      "recycler_votre_ancien_mobile",
                                    "data-oevent-action":
                                      _vm.recoveryValue.tmsAction,
                                    "data-oevent-category":
                                      _vm.recoveryValue.tmsZone,
                                    target: "_blank",
                                  },
                                })
                              : _c("ob1-liens", {
                                  staticClass: "p-0 text-left",
                                  attrs: {
                                    "is-button": "",
                                    "modal-id": "mobile-recovery-simulator",
                                    "data-toggle": "modal",
                                    text: _vm.recoveryValue.label,
                                    "data-oevent-label":
                                      "estimer_votre_mobile_actuel",
                                    "data-oevent-action":
                                      _vm.recoveryValue.tmsAction,
                                    "data-oevent-category":
                                      _vm.recoveryValue.tmsZone,
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "col-12 col-md-4 pl-0 font-weight-bold amount",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.recoveryValue.details) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.recoveryValue.simulatorUrl
                          ? _c("mobile-recovery-simulator-modal", {
                              attrs: {
                                "modal-id": "mobile-recovery-simulator",
                                title:
                                  _vm.refundMessages.recoverySimulator.title,
                                subtitle:
                                  _vm.refundMessages.recoverySimulator.subtitle,
                                url: _vm.recoveryValue.simulatorUrl,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.bonus
                      ? _c(
                          "li",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "col-12 col-md-8 pl-0" },
                              [
                                _c("ob1-liens", {
                                  staticClass: "p-0 text-left",
                                  attrs: {
                                    "is-button": "",
                                    "modal-id": "mobile-bonus-recovery",
                                    "data-toggle": "modal",
                                    text: _vm.refundMessages.bonusTitle,
                                    "data-oevent-label":
                                      "vers_popin_bonus_reprise",
                                    "data-oevent-category":
                                      "bonus_reprise_fiche_produit",
                                    "data-oevent-action":
                                      _vm.bonus.amountInCents / 100 +
                                      "€_sur_votre_nouveau_mobile",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "col-12 col-md-4 pl-0 font-weight-bold amount",
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.bonusAmountFormat)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.bonus
                              ? _c("bonus-popin", {
                                  attrs: {
                                    "modal-id": "mobile-bonus-recovery",
                                    conditions: _vm.bonus.conditions,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("mobile-recovery-details-modal", {
                    attrs: {
                      "modal-id": "mobile-recovery-popin",
                      "online-recovery": _vm.onlineRecovery
                        ? _vm.refundMessages.recoveryModal.onlineRecovery
                        : null,
                      "store-recovery": _vm.storeRecovery
                        ? _vm.refundMessages.recoveryModal.storeRecovery
                        : null,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }